const MenuIcon = () => (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Main menu">
        <path d="M15.5 12C15.5 12.6906 14.9406 13.25 14.25 13.25H1.75C1.05938 13.25 0.5 12.6906 0.5 12C0.5 11.3094 1.05938 10.75 1.75 10.75H14.25C14.9406 10.75 15.5 11.3094 15.5 12ZM14.25 5.75H1.75C1.05938 5.75 0.5 6.30938 0.5 7C0.5 7.69062 1.05938 8.25 1.75 8.25H14.25C14.9406 8.25 15.5 7.69062 15.5 7C15.5 6.30938 14.9406 5.75 14.25 5.75ZM1.75 3.25H14.25C14.9406 3.25 15.5 2.69062 15.5 2C15.5 1.30938 14.9406 0.75 14.25 0.75H1.75C1.05938 0.75 0.5 1.30938 0.5 2C0.5 2.69062 1.05938 3.25 1.75 3.25Z" fill="#667085"/>
    </svg>
);

export default MenuIcon
